var map = {
	"./1.png": 24882,
	"./1.svg": 12933,
	"./10.png": 99690,
	"./11.png": 80446,
	"./12.png": 91763,
	"./13.png": 55279,
	"./2.png": 53894,
	"./2.svg": 59394,
	"./3.png": 27135,
	"./3.svg": 99069,
	"./4.png": 63674,
	"./4.svg": 10321,
	"./5.png": 95900,
	"./6.png": 57567,
	"./7.png": 477,
	"./8.png": 70332,
	"./9.png": 84365,
	"./all.png": 5886,
	"./card-bg.png": 22585,
	"./clg.png": 86680,
	"./collegenotice.png": 75345,
	"./globallnotice.png": 16215,
	"./kmit-logo.png": 23964,
	"./kmit.png": 89495,
	"./ngit.png": 61562,
	"./tesseract-logo.png": 60781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31549;